import { useRegisterSW } from 'virtual:pwa-register/react';

/** Registers the PWA service worker. Updates apply on the next visit, with no in-app banner. */
export function PWAUpdatePrompt() {
  useRegisterSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      window.setInterval(() => {
        void registration.update();
      }, 60 * 60 * 1000);
    },
    onRegisterError(error) {
      console.error('[PWA] Service Worker registration error:', error);
    },
  });

  return null;
}
